export default "__VITE_ASSET__C7IWc8MB__"